const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js